import type { DataIdentifier, LegacyUserAuthScope } from '@onefootprint/request-types';

/**
 * Sensitive DIs that require `sensitive_profile` scope to decrypt.
 * These fields are only decryptable if the user has authenticated with biometric.
 */
const SENSITIVE_DIS: DataIdentifier[] = ['id.ssn4', 'id.ssn9', 'id.itin', 'id.us_tax_id'];

/**
 * Filters out sensitive DIs from the list if the token doesn't have the `sensitive_profile` scope.
 * This prevents 403 errors when trying to decrypt fields the token doesn't have permission for.
 */
export const filterSensitiveDis = (fields: DataIdentifier[], scopes: LegacyUserAuthScope[]): DataIdentifier[] => {
  const canDecryptSensitive = scopes.includes('sensitive_profile');

  if (canDecryptSensitive) {
    return fields;
  }

  return fields.filter(field => !SENSITIVE_DIS.includes(field));
};
